import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useProviderType = () => {
  const { t } = useTranslation();
  const [value, setValue] = useState();

  if (!value) {
    setValue([
      { label: t('GENERAL.centers'), value: 'C' },
      { label: t('GENERAL.professionals'), value: 'P' },
    ]);
  }

  return value;
};

export { useProviderType };
